import { render, staticRenderFns } from "./FilterCardPaginationMenu.vue?vue&type=template&id=2d6c0072&scoped=true"
import script from "./FilterCardPaginationMenu.vue?vue&type=script&lang=ts"
export * from "./FilterCardPaginationMenu.vue?vue&type=script&lang=ts"
import style0 from "./FilterCardPaginationMenu.vue?vue&type=style&index=0&id=2d6c0072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6c0072",
  null
  
)

export default component.exports